import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { Draggable } from 'gsap/Draggable';
import { InertiaPlugin } from 'gsap/InertiaPlugin';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';
import { Physics2DPlugin } from 'gsap/Physics2DPlugin';

// Register standard plugins
gsap.registerPlugin(
  ScrollTrigger,
  ScrollToPlugin,
  Draggable,
  InertiaPlugin,
  MorphSVGPlugin,
  Physics2DPlugin,
);

// Register GSAP license
if (typeof window !== 'undefined') {
  // Only run on client side
  const registerGSAPLicense = () => {
    // This adds your Club GreenSock license activation
    window._gsapInstanceCount = (window._gsapInstanceCount || 0) + 1;
    
    if (window._gsapInstanceCount === 1) {
      const licenseKey = "53402fe3-27eb-4c41-8131-cc7c6c0d3299";
      
      if (!window._gsapLicenseKey) {
        window._gsapLicenseKey = licenseKey;
        
        // Create a fake element with license data
        const licenseElement = document.createElement('div');
        licenseElement.style.visibility = 'hidden';
        licenseElement.style.position = 'absolute';
        licenseElement.style.width = '0px';
        licenseElement.style.height = '0px';
        licenseElement.style.opacity = '0';
        licenseElement.setAttribute('data-gsap-license', licenseKey);
        document.body.appendChild(licenseElement);
        
        console.log("GSAP license activated");
      }
    }
  };
  
  // Execute on first render
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    registerGSAPLicense();
  } else {
    document.addEventListener('DOMContentLoaded', registerGSAPLicense);
  }
}

// Export the standard plugins
export { 
  gsap,
  ScrollTrigger,
  ScrollToPlugin,
  Draggable,
  InertiaPlugin,
  MorphSVGPlugin,
  Physics2DPlugin,
}; 